export const asmCustomer360 = {
  asmCustomer360: {
    alertErrorMessage:
      'A informação não pode ser carregada. Tente novamente mais tarde ou entre em contato com seu administrador do sistema.',
    errorMessageHeader: 'Ops! Algo deu errado',
    applyActionAlter:
      'A ação não pôde ser concluída. Tente novamente mais tarde.',
    header: {
      newTitle: "Cliente 360°",
      title: 'Perfil do cliente',
      subTitle: '{{name}} Visão 360º do cliente',
      activeCartLabel: '{{cartSize}} itens adicionados ao carrinho de compras',
      recentOrderLabel: 'Último pedido {{price}}',
      recentTicketLabel: 'Último ticket',
      signedUpAt: 'Conta criada em {{date}}',
    },
    productListing: {
      totalNoItems: 'Número total de itens {{count}}',
      totalPrice: 'Preço total {{price}}',
      showMore: 'Mostrar mais',
      showLess: 'Mostrar menos',
    },
    productItem: {
      outOfStock: 'Fora de estoque',
      quantity: 'Qte: {{count}}',
      itemPrice: 'Preço do item: {{price}}',
    },
    activeCart: {
      header: 'Carrinho de compras ativo',
      emptyDescription: 'Atualmente não há produtos ativos em seu carrinho.',
      aria: {
        linkLabel: 'Carrinho ativo {{code}}',
      },
    },
    savedCart: {
      header: 'Último carrinho de compras gravado',
      emptyDescription: 'No momento não há produtos salvos em seu carrinho.',
      aria: {
        linkLabel: 'Último carrinho de compras salvo {{code}}',
      },
    },
    productInterests: {
      header: 'Interesses',
      emptyDescription: 'Atualmente não existem itens de interesse',
    },
    profile: {
      address: 'Endereço',
      billingAddress: 'Endereço de faturamento',
      deliveryAddress: 'Endereço de entrega',
      phone1: 'Telefone 1',
      phone2: 'Telefone 2',
      paymentMethodHeader: 'Formas de pagamento salvas',
    },
    activity: {
      type: 'Tipo',
      id: 'ID',
      description: 'Descrição',
      status: 'Estado',
      created: 'Criado',
      updated: 'Atualizado',
      numberOfCartItems: 'Carrinho com {{count}} produtos',
      cart: 'Carrinho',
      order: 'Pedido',
      savedCart: 'Carrinho salvo',
      emptyStateText: 'Atualmente não há atividade registrada do cliente',
      headerText: 'Geral',
    },
    productReviews: {
      columnHeaders: {
        item: 'Item',
        dateAndStatus: 'Data/status',
        rating: 'Classificação',
        review: 'Revisão',
      },
      header: 'Revisão de produtos',
      emptyDescription: 'Não há itens de produtos revisados no momento.',
      sku: 'SKU',
    },
    supportTickets: {
      columnHeaders: {
        id: 'ID',
        headline: 'Cabeçalho',
        category: 'Categoria',
      },
      header: 'Tickets de suporte',
      emptyDescription: 'Atualmente não existem itens de ticket de suporte',
    },
    coupons: {
      headerText: 'Cupons',
      emptyDescription: 'Atualmente não há cupons',
      applyButtonText: 'Aplicar ao carrinho',
      applied: 'Cupom aplicado',
      removeButtonText: 'Remover',
    },
    promotions: {
      headerText: 'Promoções',
      emptyDescription: 'Atualmente não há promoções',
      applied: 'Promoção aplicada',
      headerName: 'Nome',
      headerAction: 'Ação',
    },
    customerCoupons: {
      headerText: 'Cupons do cliente',
      emptyDescription: 'Atualmente não há cupons do cliente',
      applyButtonText: 'Atribuir ao cliente',
      removeButtonText: 'Remover',
      availableTab: 'Disponíveis',
      sentTab: 'Enviados',
      searchBox: 'Cupom',
    },
    maps: {
      storeClosed: 'Fechado',
      storesFound: '{{ initial }} - {{ end }} de {{ total }} lojas encontradas',
    },
    overviewTab: 'Resumo',
    profileTab: 'Perfil',
    activityTab: 'Atividade',
    feedbackTab: 'Comentários',
    promotionsTab: 'Promoções',
    mapsTab: 'Mapas',
    storeLocationsTab: 'Mapas',
    aria: {
      activeCartCode: 'Carrinho ativo {{code}}',
      recentOrderCode: 'Último pedido {{code}}',
    },
    pagination: 'Paginação',
    page: 'Página {{number}}',
    emptyCellValue: '---',
  },
};
